export default "__VITE_PUBLIC_ASSET__b74fb56e__"